<template>
  <div>
    <div class="wrap1-tip">
      <i class="el-icon-info icon-info"></i>
      <p>{{ $t('pay_slip_7') }}</p>
    </div>
    <div class="pay-select">
      <div class="pay-select-left">
        <div class="year">
          <span>{{ $t('1591') }}</span>
          <el-date-picker
            class="picker"
            v-model="pay_month"
            value-format="yyyy-MM"
            size="small"
            :clearable="false"
            type="month"
            @change="awaitsendlist"
          >
          </el-date-picker>
          <i class="pay-icon el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="pay-select-right">
        <!-- 批量发送 -->
        <el-button class="btn-title" size="small" @click="onBatch" v-if="$p('menu.payroll.scheme.edit')">{{
          $t('prove_5')
        }}</el-button>
      </div>
    </div>
    <div class="wrap1-content" v-loading.lock="loading" v-if="wageLength">
      <ul>
        <li v-for="item in wageList" :key="item.sub_project_id">
          <div class="pay-info">
            <span class="name">{{ item.sub_project_name }}</span>
            <el-tag size="mini">{{ item.settlement_type_text }}</el-tag>
            <el-tag size="mini">{{ item.tax_deduction_status_text }}</el-tag>
            <el-tag v-if="Number(item.payslip_send_status)" size="mini" type="warning">
              {{ item.payslip_send_status_text }}
            </el-tag>
            <el-tag
              v-if="Number(item.payslip_send_count) && !Number(item.payslip_send_status)"
              size="mini"
              type="success"
            >
              {{ $t('pay_slip_48', { key: item.payslip_send_count }) }}
            </el-tag>
          </div>
          <div class="btn2">
            <!-- 查看设置 -->
            <el-button size="small" v-if="Number(item.payslip_send_status) === 2" @click="goToDetail(item, '4')">
              {{ $t('pay_slip_9') }}</el-button
            >
            <!-- 查看详情 -->
            <el-button size="small" v-if="Number(item.payslip_send_status) === 1" @click="goToDetail(item)">{{
              $t('pay_slip_8')
            }}</el-button>
            <!-- 取消定时 -->
            <el-button
              size="small"
              v-if="Number(item.payslip_send_status) === 2 && !item.is_cancel_sent && $p('menu.payroll.scheme.edit')"
              disabled
            >
              <el-tooltip effect="dark" :content="$t('pay_slip_43')" placement="top-start">
                <span>{{ $t('pay_slip_11') }}</span>
              </el-tooltip>
            </el-button>
            <el-button
              size="small"
              v-if="Number(item.payslip_send_status) === 2 && item.is_cancel_sent && $p('menu.payroll.scheme.edit')"
              @click="cacleSend(item)"
              >{{ $t('pay_slip_11') }}</el-button
            >
            <!-- 去发工资条 -->
            <el-button
              size="small"
              v-if="!Number(item.payslip_send_status) && $p('menu.payroll.scheme.edit')"
              type="primary"
              @click="goToDetail(item, '3')"
              >{{ $t('pay_slip_10') }}</el-button
            >
          </div>
        </li>
      </ul>
    </div>
    <div class="not-data" v-else>
      <img src="@/assets/img/icon-not.png" alt="" />
      <span>{{ $t('no_data') }}</span>
    </div>
    <el-dialog :title="$t('prove_5')" :visible.sync="dialogBatch" width="100%" class="batch-dialog">
      <div class="year">
        <span>{{ $t('i18n.e7c3cbbbd24046b2b870550486d32006') }} </span>
        <el-date-picker
          class="picker"
          v-model="batch_month"
          value-format="yyyy-MM"
          size="small"
          type="month"
          :clearable="false"
          @change="payrollSubProjectList"
        >
        </el-date-picker>
      </div>
      <el-table
        class="batchTable"
        ref="table"
        style="width: 100%"
        :data="batchData"
        :max-height="300"
        @selection-change="handleSelectionChange"
      >
        <el-table-column :selectable="selectable" type="selection" width="60"> </el-table-column>
        <el-table-column :label="$t('payroll_wage_16')" prop="sub_project_name"></el-table-column>
        <el-table-column :label="$t('33')" prop="settlement_type_text"></el-table-column>
        <el-table-column :label="$t('421')" prop="tax_deduction_status_text"></el-table-column>
        <el-table-column :label="$t('payroll_wage_5')" prop="settlement_type_text">
          <template slot-scope="{ row }"> {{ row.start_date }} {{ $t('409') }} {{ row.end_date }} </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogBatch = false">{{ $t('cancel_btn') }}</el-button>
        <el-button size="small" :disabled="!multipleSelection.length" @click="clickConfirm" type="primary">{{
          $t('131')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('i18n.954cb29dd51844db95db43747c73e972')" :visible.sync="dialogMerge" width="500px">
      <el-checkbox v-model="isMerge">{{ $t('i18n.e97f9326ae1347ddbe03cabad2242e37') }}</el-checkbox>
      <h2 />
      <p>{{ $t('i18n.bd51137753e348879c5d537d45a4bdd1', { x: mergeCount }) }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogMerge = false">{{ $t('cancel_btn') }}</el-button>
        <el-button size="small" @click="clickMerge" type="primary">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { awaitsendlist, cancelTimedSend, batchNotic, saveBatchSend } from 'api/payroll/pay-slip'
import { getPayMonthList, payrollSubProjectList } from '@/api/payroll'
export default {
  data() {
    return {
      loading: true,
      dialogMerge: false,
      isMerge: false,
      mergeCount: 0,
      dialogBatch: false,
      batchData: [],
      batch_month: this.$route.query.month2 || '',
      pay_month: this.$route.query.month2 || '',
      wageLength: -1,
      wageList: [], // 方案列表
      multipleSelection: [], // 选中数据
      subProjectIds: [], // 选中数据id
      a: []
    }
  },
  async mounted() {
    if (!this.$route.query.month2) await this.getPayMonthList()
    await this.awaitsendlist()
  },
  methods: {
    async getPayMonthList() {
      const res = await getPayMonthList({ search_name: '', sub_project_status: '3' })
      if (res && res.code === 1) {
        this.pay_month = res.data[0]?.child[0] || this.$util.fmtDate('yyyy-MM')
        this.batch_month = res.data[0]?.child[0] || this.$util.fmtDate('yyyy-MM')
      }
    },
    onBatch() {
      this.dialogBatch = true
      this.payrollSubProjectList()
    },
    payrollSubProjectList() {
      payrollSubProjectList({
        pay_month: this.batch_month,
        sub_project_status: '3'
      }).then(({ data }) => {
        this.batchData = data
      })
    },
    clickMerge() {
      const query = {
        sub_project_id: this.subProjectIds,
        settlement_type: this.multipleSelection[0].settlement_type,
        tax_deduction_status: this.multipleSelection[0].tax_deduction_status,
        pay_month: this.batch_month,
        is_combine: this.isMerge ? '2' : '1'
      }
      saveBatchSend(query).then(({ data }) => {
        query.sub_project_id = data.id
        delete query.pay_month
        delete query.is_combine
        this.goToDetail(query, '3', 'merge')
      })
    },
    // 确认批量发送
    async clickConfirm() {
      const { data } = await batchNotic({ sub_project_id: this.subProjectIds })
      this.dialogMerge = data.is_show
      this.mergeCount = data.is_count
      if (!this.dialogMerge) this.clickMerge()
    },
    // 选中工资条
    handleSelectionChange(val) {
      this.subProjectIds = []
      val.forEach(item => {
        this.subProjectIds.push(item.sub_project_id)
      })
      this.multipleSelection = val
    },
    selectable(row) {
      // 当勾选其中一个税类型后，其他税类型的子项目勾选框禁止选中，取消勾选后，所有项目再开放选择
      const type = this.multipleSelection.length >= 1 ? this.multipleSelection[0].settlement_type : ''
      const tax_deduction_status =
        this.multipleSelection.length >= 1 ? this.multipleSelection[0].tax_deduction_status : ''
      return (
        (row.settlement_type === type || !type) &&
        (row.tax_deduction_status === tax_deduction_status || !tax_deduction_status)
      )
    },
    // 工资条列表
    async awaitsendlist() {
      if (!this.pay_month) {
        this.$message.warning(this.$t('payroll_salary_28'))
        return
      }
      this.loading = true
      this.$router.push({ query: { active: '2', month2: this.pay_month } })
      awaitsendlist({ pay_month: this.pay_month })
        .then(res => {
          if (res && res.code === 1) this.wageList = res.data
          this.wageLength = res.data.length
        })
        .finally(() => (this.loading = false))
    },
    cacleSend(item) {
      // 取消定时器
      this.$confirm(this.$t('pay_slip_47'), this.$t('pay_slip_11'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(async () => {
          cancelTimedSend({ payslip_id: item.payslip_id }).then(res => {
            if (res && res.code === 1) {
              this.awaitsendlist()
              this.$message.success(res.message)
            }
          })
        })
        .catch(() => {})
    },
    goToDetail(item, state, type) {
      // 跳转配置页
      let api = ''
      if (state === '4') api = '/payroll/setpay-pay-slip/' + item.payslip_id
      else if (state === '3') api = '/payroll/paywages-pay-slip/' + item.sub_project_id
      else api = '/payroll/pay-send-results/' + item.payslip_id
      const query = {
        ...this.$route.query,
        month2: this.$route.query.month2 || this.batch_month,
        payslip_scheme_id: item.id,
        type: item.settlement_type,
        tax_deduction_status: item.tax_deduction_status,
        merge: type,
        state
      }
      this.$router.push({
        path: api,
        query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1-content {
  width: 100%;
  overflow: hidden;
  ul {
    width: 100%;
    overflow-x: auto;
    li {
      min-width: 1000px;
    }
  }
}
.pay {
  &-select {
    display: flex;
    .year {
      display: inline-block;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      position: relative;
      span {
        color: #8c8c8c;
        position: absolute;
        left: 12px;
        top: 8px;
        z-index: 2;
      }
      .pay-icon {
        position: absolute;
        right: 12px;
        top: 8px;
        z-index: 2;
      }
      /deep/.picker {
        max-width: 256px;
        font-size: 14px;
        .el-input__inner {
          padding-left: 100px;
          padding-right: 0px;
          cursor: pointer;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
    &-left {
      padding: 14px 0;
      flex: 1;
    }
    &-right {
      padding: 14px 0;
      .btn-title {
        color: #5D51DA;
        border-color: #5D51DA;
      }
    }
  }
  /deep/ .el-radio-group {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #fff;
      color: #5D51DA;
    }
  }
}
.batch-dialog {
  .year {
    margin-bottom: 24px;
  }
  .batchTable {
    /deep/.el-table__header-wrapper .el-checkbox {
      display: none;
    }
  }
}
</style>
